<script>
    import { Router, links, Link, Route, navigate } from "svelte-routing";
    import { onMount, onDestroy, tick, afterUpdate, getContext } from "svelte";
    import { pSuccess, pError, pAlert } from "../utils/notify.html";
    import { activeMenu } from "../stores";
    import ButtonLoader from "../utils/button_loader.html"
    import api_handleApiCalls from "../utils/apiCallHandler.js";
    import MODULES from "../utils/modules.js" 
  

    export let testObj
    export let updateParent
    let batchWiseResultObj = {}
    let batchArr = []
    let tableArr = []
    let testSections = [];
    testSections = testObj?testObj.sections? testObj.sections : [] : [];
    let emptyState = false;
    let aBatchId

    async function api_getBatchWiseTest(_id) {
  
      let action = "test.getBatchWiseResult";
      var response = await api_handleApiCalls(action,{ testId: _id });
      return response;
  
    }
  
    function forBatchArrIndex(batchObj){

      return batchObj._id == aBatchId

    }

    function forABatchDetails(batchId){

      aBatchId = batchId
      var indx = batchArr.findIndex(forBatchArrIndex);
      return batchArr[indx].name

    }
  
    onMount(async function () {

      testObj.menu = "batchwiseresult"
      if(updateParent) updateParent()

      feather.replace();
      activeMenu.set('tests')

      var result = await api_getBatchWiseTest(testObj._id);

      if(result.status){
        batchWiseResultObj = result.data.batchWiseResult
        batchArr = result.data.batchArr
      }

      if(!batchArr.length) {
        emptyState = true
        tableArr = []
        return;
      }
      else emptyState = false

      tableArr = Object.keys(batchWiseResultObj)

      for(let i = 0; i < tableArr.length; i++){

        var batch = batchWiseResultObj[tableArr[i]]
        for(let j = 0; j < batch.length; j++){

          if(j == 0) var percentileMarks = batch[j].total.totalMarks

          batch[j].totalMarksForPercentile = percentileMarks
          batch[j].sections = testSections

        }
        batchWiseResultObj[tableArr[i]] = batch;

        for(let q = 0; q < (testObj.sections).length; q++){
                var sectionqIdArr = testObj.sections[q].questions
                var sectionTitle = testObj.sections[q].title
                for(let j = 0; j < batchWiseResultObj[tableArr[i]].length; j++){
                    var sectionalAttempt = 0
                    var sectionalCorrect = 0
                    var sectionalWrong = 0
                    var sectionalScore = 0
                    if(!(batchWiseResultObj[tableArr[i]][j].sectionalData && Object.keys(batchWiseResultObj[tableArr[i]][j].sectionalData))) batchWiseResultObj[tableArr[i]][j].sectionalData = {}

                    var ex = batchWiseResultObj[tableArr[i]][j].testStats.map(item=>{

                        for(let k = 0; k < sectionqIdArr.length; k++){

                            if(item.questionId == sectionqIdArr[k]){
                                
                              if(item.answer)sectionalAttempt = sectionalAttempt + 1;
                                
                                if(item.correct) sectionalCorrect = sectionalCorrect + 1;
                                if(!item.correct && item.hasOwnProperty("correct")) sectionalWrong = sectionalWrong + 1;

                                sectionalScore = (item.marks? item.marks : Number(0)) + sectionalScore;
                            }

                        }
                    })

                    var xx = batchWiseResultObj[tableArr[i]][j].sections.map(item=>{
                        if(item.title == sectionTitle) {
                            batchWiseResultObj[tableArr[i]][j].sectionalData[sectionTitle] =  {
                                attempt : sectionalAttempt,
                                correct : sectionalCorrect,
                                wrong   : sectionalWrong,
                                score   : sectionalScore
                            }
                            
                        }
                    })
                }
        }

        

      }

    });

    function handleNameClick(studentId){
        var testId = testObj._id
        navigate("/dashboard/tests/view/studentdetailedreport"+ "/" + studentId + "/" + testId);
        
    }

  </script>
  <div class="content-body fadeIn">
  
      <div class="pd-l-20 pd-r-20 pd-b-20">
          
        <div class="df-example demo-table" style="width: 100%;">
          {#each tableArr as batchTable}
            <table  class="table table-bordered mg-b-20 pd-20" style="width: 100%">
              <thead>
                <tr>
                  <th colspan="10" style="border: none;"> <h4 class="mg-5">{forABatchDetails(batchTable)}</h4> </th>
                </tr>
                  <tr>
                      <th rowspan="2"> Rank</th>
                      <th rowspan="2" style="width: 40%;">Student name</th>
                      {#each testSections as section}
                          <th colspan="4"><span style="text-align: center;">{section.title} </span><div>(Total Questios: {(section.questions).length})</div></th>
                      {/each}
                      <th rowspan="2"> Total Score</th>
                      <th rowspan="2"> Percentile (%)</th>
                      <th rowspan="2"> Percentage (%)</th>
                      <th rowspan="2"> Acc. (%)</th>
                      <th rowspan="2"> Time Taken</th>
                  </tr>
                  <tr>
                      {#each testSections as section}
                          <th>A</th>
                          <th>C</th>
                          <th>W</th>
                          <th>Score</th>
                      {/each}
                  </tr>

              </thead>
              {#each batchWiseResultObj[batchTable] as result}
              <tbody class="list-group-flush tx-13">
                  <tr>
                      <td>{result.rank}</td>
                      <td style="cursor: pointer;" class="row mg-0 pd-0" on:click={()=>{handleNameClick(result.userData._id)}}>
                          <img src={
                              result.userData.profilePic ? result.userData.profilePic : "/images/man.png"
                              } class="avatar rounded-circle mg-r-15" alt={result.userData.name[0].toUpperCase()}>

                              <div class="bg-transparent" style="flex: 1">
                                  <h6 style = "cursor:pointer" class="tx-13 tx-inverse tx-semibold mg-b-0 bg-transparent btn-edit-student tx-capitalize">{
                                    result.userData.name || "-"
                                  }</h6>
                                  <span class="d-block tx-11 text-muted bg-transparent">
                                      <i data-feather="phone" class="wd-15"></i> 
                                      {result.userData.mobileNo || "-"}
                                  </span>
                              </div>
                      </td>
                      {#each testSections as section}
                      <td>{result.sectionalData[section.title].attempt}</td>
                      <td>{result.sectionalData[section.title].correct}</td>
                      <td>{result.sectionalData[section.title].wrong}</td>
                      <td>{result.sectionalData[section.title].score}</td>
                      {/each}
                      <td>{result.total.totalMarks}</td>
                      <td>
                        {#if result.totalMarksForPercentile != 0}
                          {((result.total.totalMarks/result.totalMarksForPercentile)*100).toFixed(2)} %
                        {:else if  result.total.totalMarks == 0}
                           100 %
                        {:else}
                           0 %
                        {/if}
                      </td>
                      <td>
                        {#if result.total.maximumMarks != 0}
                           {((result.total.totalMarks/result.total.maximumMarks)*100).toFixed(2)} %
                        {:else if  result.total.totalMarks == 0}
                           0 %
                        {:else}
                           0 %
                        {/if}
                      </td>
                      <td>
                        {#if result.total.totalAttempted != 0}
                          {((result.total.totalCorrectAns/result.total.totalAttempted)*100).toFixed(2)}%
                        {:else if  result.total.totalCorrectAns == 0}
                           0 %
                        {:else}
                           0 %
                        {/if}
                      </td>
                      <td>{((Math.abs(new Date(result.startedAt) - new Date(result.endedOn)))/60000).toFixed(2) } min</td>
                  </tr>
              </tbody>
              {/each}
          </table>
            {/each}
        </div>

        {#if emptyState }
        <div class="empty-state-img" style="text-align: center;">
            <img src="/images/empty.svg" style="width: 200px" alt="empty" />
            <p class="tx-bold">No test results found.</p>
          </div>
        {/if}
    </div>
</div>
  